import $ from 'jquery';

export function inputValidationFunction(item) {

    // If radio button or checkbox.
    if ($(item).is(':radio, :checkbox')) {
        if ($(item)[0].validity.valid === false) {
            $(item).closest('.js-checkedStateTarget').next().show();
            $(item).closest('.js-checkedStateTarget').next().addClass('js-errorMessageVisible');
        } else {
            $(item).closest('.js-checkedStateTarget').next().hide();
            $(item).closest('.js-checkedStateTarget').next().removeClass('js-errorMessageVisible');
        }

    // If anything besides radio button or checkbox is being validated.
    } else {
        if ($(item)[0].validity.valid === false) {
            $(item).prev().addClass('u-color-red');
            $(item).next().show();
            $(item).next().addClass('js-errorMessageVisible');
        } else {
            $(item).prev().removeClass('u-color-red');
            $(item).next().hide();
            $(item).next().removeClass('js-errorMessageVisible');
        }
    }
}
